import { FC, ReactNode, useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { AccountStatusVariant } from "../constants";
import { cx } from "shared/utils";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  status: AccountStatusVariant;
  size?: BadgeSize;
  className?: string;
};

export const AccountStatusBadge: FC<Props> = ({
  status,
  size = BadgeSize.SM,
  className
}) => {
  const {
    variant,
    icon,
    title
  }: {
    variant: BadgeVariant;
    icon?: ReactNode;
    title?: string;
  } = useMemo(() => {
    switch (status) {
      case AccountStatusVariant.Pending:
        return {
          variant: BadgeVariant.WARNING,
          title: "Pending",
          icon: <InfoCircle size="12" className="stroke-warning-600" />
        };
      case AccountStatusVariant.NeedToReport:
        return {
          variant: BadgeVariant.BASE,
          title: "Need to report"
        };
      case AccountStatusVariant.Active:
        return {
          variant: BadgeVariant.SUCCESS,
          title: "Active"
        };
      case AccountStatusVariant.Unsubscribed:
        return {
          variant: BadgeVariant.BASE,
          title: "Unsubscribed"
        };
      case AccountStatusVariant.Rejected:
        return {
          variant: BadgeVariant.ERROR,
          title: "Rejected"
        };
      default:
        return { variant: BadgeVariant.BASE, title: status };
    }
  }, [status]);

  return (
    <Badge
      className={cx("shrink-0 items-center", className)}
      size={size}
      variant={variant}
      leftElement={icon}
    >
      {title}
    </Badge>
  );
};
